import css from './skeletonRouteHistoryListItem.module.css'
import cn from '@/utils/cn'
import FileListIcon from '@/assets/icons/fileList.svg?react'
import Skeleton from '@/shared/Loaders/Skeleton'

const SkeletonRouteHistoryListItem = () => {
  return (
    <div className={cn('inline-flex-gap gap12 center', css.wrapper)}>
      <FileListIcon height="16px" width="16px" color="var(--text-default)" style={{ flexShrink: 0 }} />
      <Skeleton style={{ borderRadius: '4px' }} height="16px" width="150px" />
    </div>
  )
}

export default SkeletonRouteHistoryListItem
